import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import './AffectedSimulation.css'
import { TooltipWrapper } from '../../AddMethods';
import { connect } from 'react-redux';
import { AffectedSimulationModalSetAction, selectedMasterPlanSetAction } from '../../../../actions/masterPlanogram/masterplanogram_action';
import Select from 'react-select'
import { submitSets } from '../../../UiComponents/SubmitSets';
import { submitCollection } from '../../../../_services/submit.service';
import { alertService } from '../../../../_services/alert.service';
class AffectedSimulationModal extends Component {
    constructor(props) {
        super(props)
        this._isMounted = false;
        this.state = {
            loadedcom:false,
            isallsimulatemodal:false,
            isAuiViewsAllow:false,
            defSaveObj:{},selectedsim:{},
            newSnapshotId:-1,
            selectedTagList:[],
            branches:[],
            departments:[],
            department_id:-1,
            branchid:-1,
            AffectedSimList:[],
            clusterid:-1,
            fieldArrayid:-1,
            editionid:-1,
            clusters:[],
            fieldArrays:[],
            editions:[],
        }
    }
    componentDidMount(){
        this._isMounted = true;
       
       
        if(this._isMounted){
            this.setState({AffectedSimList:this.props.AffectedSimList},()=>{
                this.extractUniqueValues()
            })
            this.loadBranches()
            this.loadDepartments()
        }
    }

    extractUniqueValues=()=>{
        const list = this.props.AffectedSimList;

        const uniqueClusters = [];
        const clusterMap = new Map();
        list.forEach(item => {
            if (item.clusterId && item.clusterId !== -1 && !clusterMap.has(item.clusterId)) {
                clusterMap.set(item.clusterId, {
                    clusterId: item.clusterId,
                    clusterName: item.clusterName
                });
                uniqueClusters.push({
                    clusterId: item.clusterId,
                    clusterName: item.clusterName
                });
            }
        });

        const uniqueFieldArrays = [];
        const fieldArrayMap = new Map();
        list.forEach(item => {
            if (item.fieldArrayId && item.fieldArrayId !== -1 && !fieldArrayMap.has(item.fieldArrayId)) {
                fieldArrayMap.set(item.fieldArrayId, {
                    fieldArrayId: item.fieldArrayId,
                    fieldArrayName: item.fieldArrayName
                });
                uniqueFieldArrays.push({
                    fieldArrayId: item.fieldArrayId,
                    fieldArrayName: item.fieldArrayName
                });
            }
        });

        const uniqueEditions = [];
        const editionMap = new Map();
        list.forEach(item => {
            if (item.editionId && item.editionId !== -1 && !editionMap.has(item.editionId)) {
                editionMap.set(item.editionId, {
                    editionId: item.editionId,
                    editionName: item.editionName
                });
                uniqueEditions.push({
                    editionId: item.editionId,
                    editionName: item.editionName
                });
            }
        });

        this.setState({
            clusters: uniqueClusters,
            fieldArrays: uniqueFieldArrays,
            editions: uniqueEditions
        });
    }
    SimulatetoSnapshot=(val)=>{
        try {
            // use clusterFieldArrayId if available, keep fieldArrayId as fallback
            const clusterFieldArrayId = val.clusterFieldArrayId || val.fieldArrayId;

            var reduxobj={
                department:{
                    department_id:val.departmentId,department_name:val.departmentName
                },
                simulationSnapshotId:val.simulationSnapshotId,
                selectedTagList:val.tags || [],
                fieldCount:val.fieldCount,
                store:{
                    id:val.storeId,name:val.storeName
                },
                fixed_percentage:val.fixed_percentage,
                cluster:{
                    id:val.clusterId,name:val.clusterName
                },
                fieldArray:{
                    id:val.fieldArrayId,name:val.fieldArrayName
                },
                edition:{
                    id:val.editionId,name:val.editionName
                },
                clusterFieldArrayId: clusterFieldArrayId
            }

            // create department object for PrePlan navigation
            let deptObj = {
                department: {
                    department_id: val.departmentId,
                    department_name: val.departmentName
                },
                mp_id: -1,
                categories: []
            }

            // store in localStorage for the new tab
            const transferData = {
                affectedSimData: reduxobj,
                deptData: deptObj,
                timestamp: Date.now()
            }
            localStorage.setItem('planigo_affected_sim_transfer', JSON.stringify(transferData));
            window.open("/masterplanograms/v2/layoutview_V2?fromAffectedSim=true", '_blank');
        } catch (error) {
            console.error('error in SimulatetoSnapshot:', error);
        }
    }
    tagslistshow=(list)=>{
        var text=""
        for (let i = 0; i < list.length; i++) {
            const element = list[i];
            if(i===0){
                text=element.tagName
            }else{
                text=text+(","+element.tagName)
            }
           
        }
        return text
    }
      // load branches
    loadBranches=()=>{
        // var departmentId =(this.state.department_id)? this.state.department_id:-1
        var sobj={
            filterOpt: "",
            // isReqCount:false,
            isReqPagination:false
            // maxResult
            // startIndex
        }
        submitSets(submitCollection.getBranches, sobj, true).then(res => {
            if (res&&res.status) {
                let cbranches=[]
                res.extra.forEach(element => {
                    let obj=element
                    obj.storeName=element.name;
                    obj.storeId=element.branchId;
                    cbranches.push(obj)
                });
                this.setState({branches:cbranches},()=>{
                    this.setState({selectedBranchidx:  this.props.isopenfromAffectedSimList?(this.state.branches.length>0?this.state.branches.findIndex(x=>x.storeId===this.props.selectedBranch.id):-1):-1})
                })
            }else{
                alertService.error(this.props.t('DATA_LOADING_FAIL'))
            }
        })
    }
    // load loadDepartments
    loadDepartments=()=>{
        var svobj ={isReqPagination:false,name:""}
        submitSets(submitCollection.mpDepartmentList,svobj, true).then(res => {
            if (res&&res.status) {
                this.setState({departments:res.extra},()=>{
                   
                })
            }else{
                alertService.error(this.props.t('DATA_LOADING_FAIL'))
            }
        })
    }
    toggleDepartment=(evt)=>{
        this.setState({department_id:evt?evt.value:-1,
            // branches:[],branchid:-1
        },()=>{
            this.handleFilterResults()
            this.loadBranches()
        })
    }
    toggleBranches=(evt)=>{
        this.setState({branchid:evt?evt.value:-1},()=>{
            this.handleFilterResults()
        })
    }

    toggleCluster=(evt)=>{
        this.setState({clusterid:evt?evt.value:-1},()=>{
            this.handleFilterResults()
        })
    }

    toggleFieldArray=(evt)=>{
        this.setState({fieldArrayid:evt?evt.value:-1},()=>{
            this.handleFilterResults()
        })
    }

    toggleEdition=(evt)=>{
        this.setState({editionid:evt?evt.value:-1},()=>{
            this.handleFilterResults()
        })
    }
    
    handleFilterResults = (ctxt,isReSerach) => {
        let list=structuredClone(this.props.AffectedSimList)
        const filteredByMultipleCriteria = filterObjects(list, {
            departmentId: this.state.department_id,
            storeId: this.state.branchid,
            clusterId: this.state.clusterid,
            fieldArrayId: this.state.fieldArrayid,
            editionId: this.state.editionid
        });

        this.setState({AffectedSimList:filteredByMultipleCriteria})
    }
    render() {
        // var {AffectedSimList}=this.props
        var {branches,departments,AffectedSimList,branchid,clusters,fieldArrays,editions,clusterid,fieldArrayid,editionid}=this.state
        let filterBranchList = (branches&&branches.length>0)?branches.map((item,i)=>{
            return {value:item.storeId,label:item.storeName,idx:i}
        }):[{value:-1,label:this.props.t("NO_RESULT_FOUND")}];

        let filterDepartments = (departments&&departments.length>0)?departments.map((item,i)=>{
            return {value:item.departmentId,label:item.departmentName,idx:i}
        }):[{value:-1,label:this.props.t("NO_RESULT_FOUND")}];

        let filterClusterList = (clusters&&clusters.length>0)?clusters.map((item,i)=>{
            return {value:item.clusterId,label:item.clusterName,idx:i}
        }):[{value:-1,label:this.props.t("NO_RESULT_FOUND")}];

        let filterFieldArrayList = (fieldArrays&&fieldArrays.length>0)?fieldArrays.map((item,i)=>{
            return {value:item.fieldArrayId,label:item.fieldArrayName,idx:i}
        }):[{value:-1,label:this.props.t("NO_RESULT_FOUND")}];

        let filterEditionList = (editions&&editions.length>0)?editions.map((item,i)=>{
            return {value:item.editionId,label:item.editionName,idx:i}
        }):[{value:-1,label:this.props.t("NO_RESULT_FOUND")}];
        return (
            <Modal className="planigo-Modal affectedsimmodal" dir={this.props.isRTL} size='xl' centered show={this.props.isShow}  backdrop="static"
            // onShow={()=>this.handlecomploaded()}
            onHide={()=>this.props.isShowHandle()}>
            <Modal.Body>
                <Modal.Header>
                    <Modal.Title>
                    {  this.props.t("Simulations_have_issues") }
                    </Modal.Title>
                    <Button className='btn-close' onClick={()=>this.props.isShowHandle()}></Button>
                </Modal.Header>
                <div>
                <div className='Aff-simModal-filters'>
                        <ul className='list-inline simulate-filters'>
                            <li className='list-inline-item filter-item'>
                                <div className='form-group'>
                                    <label>
                                        {this.props.t("Cluster")}
                                    </label>
                                    <Select
                                        isClearable
                                        menuPlacement="bottom"
                                        placeholder={this.props.t("SELECT_CLUSTER")}
                                        options={filterClusterList}
                                        onChange={(e)=>this.toggleCluster(e)}
                                        value={clusterid>-1?filterClusterList[clusters.findIndex(x=>x.clusterId===clusterid)]:null}
                                        className="filter-selec2" size="sm" classNamePrefix="searchselect-inner"
                                        maxMenuHeight={160}
                                        />
                                </div>
                            </li>
                            <li className='list-inline-item filter-item'>
                                <div className='form-group'>
                                    <label>
                                        {this.props.t("FIELD_ARRAY_NAME")}
                                    </label>
                                    <Select
                                        isClearable
                                        menuPlacement="bottom"
                                        placeholder={this.props.t("SELECT_FIELD_ARRAY")}
                                        options={filterFieldArrayList}
                                        onChange={(e)=>this.toggleFieldArray(e)}
                                        value={fieldArrayid>-1?filterFieldArrayList[fieldArrays.findIndex(x=>x.fieldArrayId===fieldArrayid)]:null}
                                        className="filter-selec2" size="sm" classNamePrefix="searchselect-inner"
                                        maxMenuHeight={160}
                                        />
                                </div>
                            </li>
                            <li className='list-inline-item filter-item'>
                                <div className='form-group'>
                                    <label>
                                        {this.props.t("EDITION")}
                                    </label>
                                    <Select
                                        isClearable
                                        menuPlacement="bottom"
                                        placeholder={this.props.t("SELECT_EDITION")}
                                        options={filterEditionList}
                                        onChange={(e)=>this.toggleEdition(e)}
                                        value={editionid>-1?filterEditionList[editions.findIndex(x=>x.editionId===editionid)]:null}
                                        className="filter-selec2" size="sm" classNamePrefix="searchselect-inner"
                                        maxMenuHeight={160}
                                        />
                                </div>
                            </li>
                            <li className='list-inline-item filter-item'>
                                <div className='form-group'>
                                    <label>
                                        {this.props.t("branch")}
                                    </label>
                                    <Select
                                        isClearable
                                        menuPlacement="bottom"
                                        placeholder={this.props.t("SELECT_BRANCH")}
                                        options={filterBranchList}
                                        onChange={(e)=>this.toggleBranches(e)}
                                        value={branchid>-1?filterBranchList[branches.findIndex(x=>x.storeId===branchid)]:null}
                                        className="filter-selec2" size="sm" classNamePrefix="searchselect-inner"
                                        maxMenuHeight={160}
                                        />
                                </div>
                            </li>
                            <li className='list-inline-item filter-item'>
                                <div className='form-group'>
                                    <label>
                                        {this.props.t("department")}
                                    </label>
                                    <Select
                                        isClearable
                                        menuPlacement="bottom"
                                        placeholder={this.props.t("selectdepartment")}
                                        options={filterDepartments}
                                        onChange={(e)=>this.toggleDepartment(e)}
                                        // value={this.props.selectedBranchidx>-1?filterBranchList[this.props.selectedBranchidx]:null}
                                        className="filter-selec2" size="sm" classNamePrefix="searchselect-inner"
                                        maxMenuHeight={160}
                                        />
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div className='content'>
                        {AffectedSimList.length>0?<div>
                            {AffectedSimList.map((item, i) =>
                                <div key={i} className='m-item' onClick={()=>this.SimulatetoSnapshot(item)}>
                                    <TooltipWrapper placement="bottom" text={item.clusterName || '-'} >
                                        <div className='cluster'>{item.clusterName || '-'}</div>
                                    </TooltipWrapper>

                                    <TooltipWrapper placement="bottom" text={item.fieldArrayName || '-'} >
                                        <div className='fieldArray'>{item.fieldArrayName || '-'}</div>
                                    </TooltipWrapper>

                                    <TooltipWrapper placement="bottom" text={item.editionName || '-'} >
                                        <div className='edition'>{item.editionName || '-'}</div>
                                    </TooltipWrapper>

                                    <TooltipWrapper placement="bottom" text={item.storeName || '-'} >
                                        <div className='Store'>{item.storeName || '-'}</div>
                                    </TooltipWrapper>

                                    <TooltipWrapper placement="bottom" text={item.departmentName} >
                                        <div className='dep'>{item.departmentName}</div>
                                    </TooltipWrapper>
                                </div>
                            )}
                        </div>:<div className='NoResults'>{this.props.t("NO_RESULT_FOUND")}</div>}
                    </div>
                    </div>
                
            </Modal.Body>
            </Modal>
        )
    }
}
function filterObjects(array, filterCriteria) {
    return array.filter(obj => {
      for (const key in filterCriteria) {
        const criteriaValue = filterCriteria[key];
        // Skip null or -1 criteria
        if (criteriaValue !== null && criteriaValue !== "" && criteriaValue !== -1) {
            if (typeof criteriaValue === 'string') {
                let object=JSON.stringify(obj[key])
                if(!(object.toLowerCase().includes(criteriaValue.toLowerCase()))){
                    return false;
                }
            }else
            if (obj[key] !== criteriaValue) {
                return false;
            }
        }
      }
      return true;
    });
  }

const mapDispatchToProps = dispatch => ({
    setAffectedSimulationModalData: (payload) => dispatch(AffectedSimulationModalSetAction(payload)),
    setMasterPlanAction: (payload) => dispatch(selectedMasterPlanSetAction(payload)),
});

export default withTranslation()(withRouter(connect(null, mapDispatchToProps)(AffectedSimulationModal)))